import React from 'react';
import { Box, Chip } from '@mui/material';
import { alpha } from '@mui/material/styles';

const DEFAULT_ACCENT = '#4ce1b6';

export default function ActualStayDateChips({
  actual,
  label = 'Actual',
  accent = DEFAULT_ACCENT,
  isDark = true,
}) {
  if (!actual?.date) return null;

  const outlinedSx = {
    height: 22,
    fontSize: '0.65rem',
    fontWeight: 600,
    borderColor: alpha(accent, isDark ? 0.45 : 0.35),
    color: accent,
  };
  const filledSx = {
    height: 22,
    fontSize: '0.65rem',
    fontWeight: 600,
    backgroundColor: alpha(accent, isDark ? 0.14 : 0.1),
    color: accent,
    border: `1px solid ${alpha(accent, 0.28)}`,
  };

  return (
    <Box sx={{ mt: 0.75, display: 'flex', flexWrap: 'nowrap', gap: 0.5, alignItems: 'center', overflowX: 'auto' }}>
      <Chip label={label} size="small" variant="outlined" sx={outlinedSx} />
      <Chip label={actual.date} size="small" sx={filledSx} />
      {actual.time ? <Chip label={actual.time} size="small" sx={filledSx} /> : null}
    </Box>
  );
}
